
const journeyInner = document.querySelector('.coffee-journey-inner');
const stepBlocks = document.querySelectorAll('.coffee-journey-block');
const stepOptionsBlocks = document.querySelectorAll('.coffee-journey-options-container');
const journeyError = document.querySelector('.coffee-journey-error');
const journeyNextButton = document.querySelector('.coffee-journey-next-button');
const journeyNextLabel = document.getElementById('coffee-journey-next-label');
const journeyPrevButton = document.querySelector('.coffee-journey-prev-button-container');
const journeyButtonsContainer = document.querySelector('.coffee-journey-buttons-container');
const journeyLoader = journeyInner.querySelector('.spinning-beans-loader');
const pageType = document.getElementById('coffeeJourneyPageType').value;
const mainContent = document.getElementById('MainContent');
const journeyUrlParams = new URLSearchParams(document.location.search);

const steps = [
    'brewing_method',
    'region',
    'taste_profile',
    'processes'
];
let selection = {
    brewing_method: null,
    processes: [],
    region: [],
    taste_profile: []
};
let currentStep = 0;

let resultsMode = false;
if (pageType === 'large' && journeyUrlParams) {
    let selectionParams = journeyUrlParams.get('selection');
    if (selectionParams) {
        resultsMode = true;
        journeyLoader.style.display = 'block';
        selection = JSON.parse(decodeURI(selectionParams));
        currentStep = false;
        console.log(selection);
        getOptions({
            step: 'preset',
            selection: selection
        });
    }
}

if (!resultsMode) {
    getOptions({
        step: 'brewing_method'
    });
}

journeyNextButton.addEventListener('click', (e)=>{
    e.preventDefault();
    console.log(currentStep);
    if (!selection[steps[currentStep]] || (Array.isArray(selection[steps[currentStep]]) && selection[steps[currentStep]].length === 0)) {
        journeyError.innerText = 'Please pick some options.';
        journeyError.style.display = 'block';
    }
    else {
        if (currentStep === steps.length - 1) { // show results
            getResults();
        }
        else {
            stepBlocks.forEach((block)=>{
                if (block.getAttribute('data-step') === steps[currentStep + 1]) {
                    block.style.display = 'block';
                } 
                else if (pageType === 'small') {
                    block.style.display = 'none';
                }
            });
            currentStep++;
            let data = {
                step: steps[currentStep],
                step_number: currentStep,
                selection: selection
            };
            console.log(data);
            stepOptionsBlocks[currentStep].innerHTML = '';
            getOptions(data);
            if (steps[currentStep + 1] != null && steps[currentStep + 1] != undefined){
                journeyNextLabel.innerText = steps[currentStep + 1].replace('_', ' ').toUpperCase();
            }
            else{
                journeyNextLabel.innerText = 'Find My Coffee';
            }
            if (currentStep > 0) journeyPrevButton.style.display = 'block';
            //scrollToElem(`[data-step="${steps[currentStep]}"]`);
        }
    }
});

journeyPrevButton.addEventListener('click', (e)=>{
    e.preventDefault();
    journeyError.style.display = 'none';
    clearResults();
    stepBlocks.forEach((block)=>{
        let dataStep = block.getAttribute('data-step');
        if (dataStep === steps[currentStep - 1]) {
            block.style.display = 'block';
        } 
        else if (pageType === 'small' || (dataStep === steps[currentStep] && pageType === 'large')) {
            block.style.display = 'none';
        }
    });
    currentStep--;
    rollBackStepButton();
    scrollToElem(`[data-step="${steps[currentStep]}"]`);
});

function rollBackStepButton() {
    if (steps[currentStep + 1] != null && steps[currentStep + 1] != undefined){
        journeyNextLabel.innerText = steps[currentStep + 1].replace('_', ' ').toUpperCase();
    }
    currentStep > 0 ? journeyPrevButton.style.display = 'block' : journeyPrevButton.style.display = 'none';
    for (let i = currentStep + 1; i < steps.length; i++) {
        selection[steps[i]] = [];
    }
    console.log(selection);
}

function containerHeight() {
    if (pageType === 'small') {
        if (window.innerWidth > 989){
            let top = document.querySelector('.featured-product-title-container').getBoundingClientRect().top + window.scrollY;
            let bottom = document.querySelector('.hero-modal-launcher-button').getBoundingClientRect().bottom + window.scrollY;
            let height = bottom - top;
            journeyInner.style.height = `${height}px`;
            let buttonBottom = journeyButtonsContainer.getBoundingClientRect().bottom + window.scrollY;
            journeyButtonsContainer.style.bottom = `${buttonBottom - bottom}px`;
        }
        else {
            journeyInner.style.height = 'unset';
            journeyButtonsContainer.style.bottom = 0;
        }
    }
}

function getOptions(data) {
    journeyLoader.style.display = 'block';
    fetch(`https://bailies-coffee.etempashopifyapps.co.uk/endpoints/coffee_journey_get_options.php`, {
        method: 'POST',
        mode: 'cors',
        body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(data => {
        console.log(data);
        journeyLoader.style.display = 'none'; 
        if (data.failed) {
            journeyError.innerText = data.error_message;
            journeyError.style.display = 'block';
        }
        else if (data.no_options) {
            journeyError.innerText = 'Unfortunately we can\'t find any coffees with this combination. Try going back a step and picking something else.';
            journeyError.style.display = 'block';
        }
        else {
            journeyError.style.display = 'none';
            if (currentStep || currentStep === 0) {
                createStepBlock(data.options);
                containerHeight();
            }
            else {
                currentStep = 0;
                steps.forEach((step) => {
                    createStepBlock(data.options[step]);
                    currentStep++;
                });
                for (let [key, value] of Object.entries(selection)) {
                    if (Array.isArray(value)) {
                        value.forEach((item)=>{
                            document.querySelector(`[data-step="${key}"][data-value="${item}"]`).classList.add('active');
                        });
                    }
                    else {
                        document.querySelector(`[data-step="${key}"][data-value="${value}"]`).classList.add('active');
                    }
                }
                journeyNextLabel.innerText = 'Find My Coffee';
                journeyPrevButton.style.display = 'block';
                getResults();
            }
        }
    })
    .catch(error => {
        console.error(error);
        journeyLoader.style.display = 'none';
        journeyError.innerText = 'Sorry, something has gone wrong. Please refresh the page and try again.';
        journeyError.style.display = 'block';
    })
}

function createStepBlock(optionsData) {
    currentStep === 1 || currentStep === 3 ? optionsData.forEach((option)=>createOptionCard(option.Title, option.Src, option.Snippet)) : optionsData.forEach((option)=>createOptionCard(option.Title, option.Src));
    if (currentStep > 0) createOptionCard('Any','https://etempashopifyapps.co.uk/bailies-coffee/endpoints/file_uploads/journey-all-green.svg');
    stepBlocks[currentStep].style.display = 'block';
}

function createOptionCard(optionTitle, optionSrc, optionSnippet = null) {
    let card = document.createElement('div');
    card.classList.add('journey-option-card');
    currentStep === 2 ? card.classList.add('journey-option-tag') : '';
    card.setAttribute('data-step', steps[currentStep]);
    card.setAttribute('data-value', optionTitle);

    if (currentStep !== 2) {
        let imageContainer = document.createElement('div');
        imageContainer.classList.add('journey-option-image');
        card.append(imageContainer);

        if (optionSrc) {
            fetch(optionSrc, {
                method: 'GET',
                mode: 'cors'
            })
            .then(svgResponse => svgResponse.text())
            .then(svgData => {
                imageContainer.innerHTML = svgData; 
            })
            .catch(error => {
                console.error(error);
                journeyError.innerText = 'Sorry, something has gone wrong. Please refresh the page and try again.';
                journeyError.style.display = 'block';
            })
        }
    }

    let title = document.createElement('p');
    title.classList.add('journey-option-title');
    title.innerText = optionTitle;
    card.append(title); 

    card.addEventListener('click', optionCardSelect);
    stepOptionsBlocks[currentStep].append(card);

    if (optionSnippet && currentStep !== 2) {
        let snippet = document.createElement('p');
        snippet.classList.add('journey-option-snippet');
        snippet.innerText = optionSnippet;
        card.append(snippet);
    }
}

function optionCardSelect(e) {
    clearResults();
    let _this = e.target.closest('.journey-option-card');
    let _thisStep = _this.getAttribute('data-step');
    let _thisValue = _this.getAttribute('data-value');
    let _thisIndex = parseInt(steps.findIndex((val)=>{return val === _thisStep}));
    if (pageType === 'large' && _thisIndex > -1) {
        for (let i = _thisIndex + 1; i < stepBlocks.length; i++) {
            stepBlocks[i].style.display = 'none';
        }
        currentStep = _thisIndex;
        rollBackStepButton();
    }
    if (_thisStep === steps[0]) {
        _this.parentElement.querySelectorAll('.journey-option-card').forEach(i=>i.classList.remove('active'));
        _this.classList.add('active');
        selection[_thisStep] = _thisValue;
    }
    else {
       if (_thisValue === 'Any') {
            _this.parentElement.querySelectorAll('.journey-option-card').forEach(i=>i.classList.remove('active'));
            selection[_thisStep] = ['Any'];
       }
       else {
        if (selection[_thisStep].includes('Any')) {
            selection[_thisStep] = [];
            _this.parentElement.querySelector('[data-value="Any"]').classList.remove('active');
        }
       }
       if (_this.classList.contains('active')) {
            _this.classList.remove('active');
            console.log(_thisValue);
            console.log(selection[_thisStep]);
            if (selection[_thisStep].includes(_thisValue)) selection[_thisStep] = selection[_thisStep].filter((item)=>{ return item !== _thisValue });
       }
       else {
            _this.classList.add('active');
            if (!selection[_thisStep].includes(_thisValue)) selection[_thisStep].push(_thisValue);
       }
    }
    console.log(selection);
}

function getResults() {
    journeyLoader.style.display = 'block';
    clearResults();
    if (pageType === 'large') {
        fetch(`https://bailies-coffee.etempashopifyapps.co.uk/endpoints/coffee_journey_get_options.php`, {
            method: 'POST',
            mode: 'cors',
            body: JSON.stringify({
                step: "results",
                selection: selection
            })
        })
        .then(response => response.json())
        .then(data => {
            console.log(data);
            if (data.failed) {
                journeyError.innerText = data.error_message;
                journeyError.style.display = 'block';
            }
            else if (data.no_options || data.results.length === 0) {
                journeyError.innerText = 'Unfortunately we can\'t find any coffees with this combination. Try going back a step and picking something else.';
                journeyError.style.display = 'block';
            }
            else {
                // console.log(data.results.join(','));
                journeyError.style.display = 'none';
                fetch(`/pages/coffee-journey-results?section_id=coffee-journey-results&result=${data.results.join(',')}`)
                .then(response => response.text())
                .then(html => {
                    let parser = new DOMParser();
                    let resultsHtml = parser.parseFromString(html, 'text/html');
                    let resultsSection = resultsHtml.querySelector('.coffee-journey-results-section');
                    mainContent.append(resultsSection);
                    journeyLoader.style.display = 'none';
                    scrollToElem('.coffee-journey-results-section');
                })
                .catch(error => {
                    console.error(error);
                    journeyError.innerText = 'Sorry, something has gone wrong fetching your results. Please refresh the page and try again.';
                    journeyError.style.display = 'block';
                })
            }
        })
        .catch(error => {
            console.error(error);
            journeyLoader.style.display = 'none';
            journeyError.innerText = 'Sorry, something has gone wrong fetching your results. Please refresh the page and try again.';
            journeyError.style.display = 'block';
        })
    }
    else {
        let url = encodeURI(`/pages/find-your-perfect-coffee?selection=${JSON.stringify(selection)}`);
        window.location.href = url;
    }
}

function scrollToElem(elem) {
    if (pageType === 'large') {
        let elemTop = document.querySelector(elem).getBoundingClientRect().top;
        let bodyTop = document.body.getBoundingClientRect().top;
        let difference = elemTop - bodyTop - 100;
        window.scrollTo({
            top: difference,
            behaviour: 'smooth'
        });
    }
}

function clearResults() {
    if (pageType === 'large') {
        let currentResults = document.querySelector('.coffee-journey-results-section');
        if (currentResults) currentResults.remove();
    }
}

window.onresize = containerHeight;